import { useEffect, useState } from "react";

import { ItemsHeader } from "../ui/ItemsHeader";
import { useGetDatasetGroups } from "@/queries/datasets/useGetDatasetGroups";
import { DatasetPageContent } from "./DatasetPageContent";
import UserChannelProvider from "../UserChannelProvider";

const NewDatasetGroupGrid = () => {
  const [searchQuery, setSearchQuery] = useState<string>("");

  const {
    data: datasetGroups,
    isLoading,
    page,
    setPage,
    pageSize,
  } = useGetDatasetGroups({
    search: searchQuery,
  });

  useEffect(() => {
    if (searchQuery && page !== 1) {
      setPage(1);
    }
  }, [searchQuery]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <UserChannelProvider>
      <ItemsHeader
        searchPlaceholder="by column name or dataset name"
        searchValue={searchQuery}
        onSearchChange={(e) => setSearchQuery(e.target.value)}
        currentPage={page}
        onPrevPage={() => setPage(page - 1)}
        onNextPage={() => setPage(page + 1)}
        itemsLength={datasetGroups?.total || 0}
        itemsPerPage={pageSize}
      >
        <DatasetPageContent
          datasetGroupList={datasetGroups?.dataset_groups || []}
          isLoading={isLoading}
        />
      </ItemsHeader>
    </UserChannelProvider>
  );
};

export default NewDatasetGroupGrid;
